import React from 'react';
import SVGIcon from '../components/SVGIcon';
import PopOver from '../components/deprecated/PopOver';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import seriesIcon from '../icons/non-prefilled/16x16/series.svg';
import SeriesHoverCard from '../series/SeriesHoverCard';
import styles from './PostSeriesBar.module.scss';

const SERIES_FRAGMENT = gql(`
  fragment PostSeriesBar_series on PublicSeriesFields {
    id
    name
    posts {
      id
    }
  }
`);

interface PostSeriesBarProps {
  postId: string;
  series: DocumentType<typeof SERIES_FRAGMENT>;
}

const PostSeriesBar = ({ postId, series }: PostSeriesBarProps) => {
  const index = series.posts.findIndex(({ id }) => id === postId);

  return (
    <div className={styles.container}>
      <SVGIcon className={styles.icon} size={16}>
        {seriesIcon}
      </SVGIcon>
      <div>
        <PopOver
          display="inline-block"
          placement="bottom-start"
          responsivePlacement="bottom"
          trigger="hover"
          popOver={<SeriesHoverCard postId={postId} showEditButton />}
          popOverPortal={document.body}
        >
          Part {index + 1} of {series.posts.length} in{' '}
          <span className={styles.seriesName}>{series.name}</span>
        </PopOver>
      </div>
    </div>
  );
};

export default PostSeriesBar;
